import { ROUTE_ACTIONS } from "constants/routesValues";

export const pushStateHistory = (data: object, route: string) => {
  window.history.pushState(data, "", route);
};

export const createRouteAction = (page: keyof typeof ROUTE_ACTIONS) => {
  const pageType = page;
  const routeAction = ROUTE_ACTIONS[pageType];

  if (!routeAction) return;

  pushStateHistory(routeAction.state, routeAction.route);
  window.dispatchEvent(new PopStateEvent("popstate"));
};
